module.exports = __webpack_public_path__ + "assets/img/recommend_icon06.0924fbe5.png";